import React from 'react';

import { Breadcrumb } from 'components/Breadcrumb';

import { MainPageLayout } from './MainPageLayout';

type MainPageTemplateProps = {
  title: string;
  links?: { text: string; href: string }[];
  rightHeader?: React.ReactNode;
  children: React.ReactNode;
};

export const MainPageTemplate = ({
  title, links, rightHeader, children,
}: MainPageTemplateProps) => {
  return (
    <MainPageLayout.Page>
      <MainPageLayout.Header>
        <Breadcrumb title={title} links={links ?? []} />
        {/* set div to right */}
        {rightHeader && <div style={{ marginLeft: 'auto' }}>{rightHeader}</div>}
      </MainPageLayout.Header>
      <MainPageLayout.Main>
        <MainPageLayout.MainContent>
          {children}
        </MainPageLayout.MainContent>
      </MainPageLayout.Main>
    </MainPageLayout.Page>
  );
};
